import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "row justify-content-center" }
const _hoisted_2 = { class: "col-12 text-center" }
const _hoisted_3 = {
  key: 0,
  class: "row d-flex justify-content-center"
}
const _hoisted_4 = { class: "col-1 mt-3 mb-3" }
const _hoisted_5 = { class: "progress-spinner progress-spinner-double size-sm progress-spinner-active" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "progress-spinner-inner" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "progress-spinner-inner" }, null, -1)
const _hoisted_8 = { class: "visually-hidden" }
const _hoisted_9 = {
  key: 1,
  class: "row justify-content-center"
}
const _hoisted_10 = {
  key: 0,
  class: "col-12"
}
const _hoisted_11 = ["onClick"]

import { onMounted, ref, inject, watch } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "../../models/Store/store";
import api from "@/services/BookingService";
import _ from "lodash";
import moment from "moment";
import { AxiosError } from "axios";
import { IntervalAvailable } from "@/models/Step/IntervalAvailableModel";
import { useI18n } from "vue-i18n";
import constants from "@/models/Utils/constants";


export default /*#__PURE__*/_defineComponent({
  __name: 'BookOrari',
  setup(__props) {

const router = useRouter();
const store = useStore();
const { t } = useI18n();
const emitter = inject("emitter");

const selectedItem = ref(null);
const loadingIntervals = ref(false);
const intervalAvailables = ref([]);

onMounted(() => {
  store.stepsMade.interval = null;
  store.spidResponse = null;

  const localeCode = t("settings.localeCode");
  moment.locale(localeCode);

  emitter.on(constants.GO_NEXT_STEP, () => {
    console.log("received goNextStep BookOrari");
    goToNextStep();
  });

  if (
    _.isNull(store.stepsMade) === false &&
    _.isNull(store.stepsMade.service) === false &&
    _.isNull(store.stepsMade.month) === false &&
    _.isNull(store.stepsMade.location) === false &&
    _.isNull(store.stepsMade.day) === false
  ) {
    getData();
  }
});

const getData = () => {
  loadingIntervals.value = true;

  let url = `v2/hours/${store.tenantSelected.id}/${
    store.stepsMade.location.id
  }/${store.stepsMade.service.id}/${store.stepsMade.month.year}/${
    store.stepsMade.month.month
  }/${store.stepsMade.day.day}/${"web"}`;

  if (store.bookedit) {
    url = url + `?bookingCode=${store.bookedit.friendlyCode}`;
  }

  api
    .getAvailableIntervals(url)
    .then((response) => {
      if (_.isNull(response) === false && _.isUndefined(response) === false) {
        if (
          _.isNull(response.data) === false &&
          _.isUndefined(response.data) === false
        ) {
          if (
            _.isArray(response.data.intervalsAvailable) &&
            response.data.intervalsAvailable.length > 0
          ) {
            for (let i = 0; i < response.data.intervalsAvailable.length; i++) {
              const interval = response.data.intervalsAvailable[i];
              intervalAvailables.value.push(interval);
            }
          }
        }
      }

      loadingIntervals.value = false;
    })
    .catch((err: AxiosError) => {
      console.log("Errore nella get degli orari");
      loadingIntervals.value = false;
    });
};

watch(
  () => selectedItem.value,
  (newVal) => {
    if (newVal) {
      emitter.emit(constants.CAN_GO_NEXT_STEP, true);
    } else {
      emitter.emit(constants.CAN_GO_NEXT_STEP, false);
    }
  },
  { immediate: true }
);

const selectedInterval = (item: IntervalAvailable) => {
  if (_.isNull(item) === false && _.isUndefined(item) === false) {
    selectedItem.value = item;
  }
};

const goToNextStep = () => {
  store.stepsMade.interval = selectedItem.value;
  router.push({ name: "bookformchoice" });
};

const isItemSelected = (item: IntervalAvailable) => {
  if (_.isNull(selectedItem.value) === false) {
    if (selectedItem.value.description === item.description) {
      return true;
    }
  }
  return false;
};

const bookEditHasSameInterval = (item: IntervalAvailable) => {
  if (_.isNull(store.bookedit) === false) {
    const fromHour = moment(store.bookedit.fromDate).format("HH:mm");
    const toHour = moment(store.bookedit.toDate).format("HH:mm");
    if (`${fromHour}-${toHour}` === item.description) {
      return true;
    }
  }
  return false;
};

const getStartIntervalDescription = (item: IntervalAvailable) => {
  return item.description.split("-")[0];
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h2", null, _toDisplayString(_unref(t)("titles.selectBookingHour")), 1)
      ])
    ]),
    (loadingIntervals.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _hoisted_7,
              _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(t)("common.loadingText")), 1)
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_9, [
          (intervalAvailables.value.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("label", null, [
                  _createElementVNode("b", null, _toDisplayString(_unref(t)("messages.noAvailability")), 1)
                ])
              ]))
            : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(intervalAvailables.value, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "col-12 col-sm-4 col-md-4 col-lg-3 col-xl-2 d-grid gap-2",
                  key: item.id
                }, [
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass(["btn btn-lg my-3", [
            isItemSelected(item) ? 'btn-primary' : 'btn-outline-primary',
          ]]),
                    onClick: ($event: any) => (selectedInterval(item))
                  }, _toDisplayString(getStartIntervalDescription(item)), 11, _hoisted_11)
                ]))
              }), 128))
        ]))
  ]))
}
}

})